import React from 'react';

const ArticleList = ({ title, items = [], onSelect }) => (
  <div className="support-card">
    <div className="support-section-title">{title}</div>
    {items.length === 0 ? (
      <div className="support-empty">No articles yet.</div>
    ) : (
      <div className="support-article-list">
        {items.map((article) => (
          <div
            key={article.id}
            className="support-article-row"
            onClick={() => onSelect(article)}
            role="button"
            tabIndex={0}
            onKeyDown={(event) => {
              if (event.key === 'Enter') onSelect(article);
            }}
          >
            <div style={{ fontWeight: 600 }}>{article.title}</div>
            <div style={{ fontSize: '0.8rem', color: '#9b9b9b' }}>{article.category}</div>
          </div>
        ))}
      </div>
    )}
  </div>
);

export default ArticleList;
